import { Navigate } from "react-router-dom";
import { primaryNavigationChecker } from "../utils/rbac";

const ProtectedRoute = ({ permissionKey, role, children }) => {
  const hasAccess = primaryNavigationChecker(permissionKey, role);

  if (!hasAccess) {
    return <Navigate to="/unauthorized" replace />;
  }

  return children;
};

export default ProtectedRoute;
